import './lib/polyfills'
import { installStaleAssetReloadHandler } from './lib/staleAssetReload'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Microsoft auth is now handled server-side (backend token exchange).
// The callback page captures the auth code and sends it to the parent
// via postMessage — no MSAL initialization needed here.

installStaleAssetReloadHandler();

createRoot(document.getElementById("root")!).render(<App />);
